import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal';

//services
import { HomeService } from '../../../pages/home/services/home.service';
import { SmService } from '../../../pages/sm/services/sm.service';

//Models
import { LineType } from '../../../shared/model/line-type.model';

@Component({
  selector: 'app-clockin-job-modal',
  templateUrl: './clockin-job-modal.component.html',
  styleUrls: ['./clockin-job-modal.component.css'],
})
export class ClockinJobModalComponent implements OnInit {
  portalSettings: any;
  employeeInfo: any;
  formData: { [key: string]: any } = {};
  tcClockIOIgnoreJobPhase: boolean;
  jobs: any[] = [];
  phases: any[] = [];
  prefillJP: boolean;
  userAction: string;
  lineTypes: LineType[] = [];
  scopeList: any[] = [];
  payTypeList: any[] = [];
  workOrderList: any[] = [];
  enabledLineTypesInClockIn: any;
  lastClockinType: any;

  constructor(
    private homeService: HomeService,
    private bsModalRef: BsModalRef,
    private smService: SmService
  ) {}

  ngOnInit(): void {
    this.prefillJP = this.portalSettings.PrefillPerviousJobPhase.ConfigValue == '1';
    this.tcClockIOIgnoreJobPhase = this.portalSettings.TCClockIOIgnoreJobPhase.ConfigValue == '1';
    this.enabledLineTypesInClockIn = this.portalSettings.EnabledLineTypesInClockIn.ConfigValue;
    this.formData.selectedJob = null;
    this.formData.selectedPhase = null;
    this.formData.lineType = null;
    this.formData.workOrder = null;
    this.formData.scope = null;
    this.formData.payType = null;

    this.formData.lineType =
      this.lineTypes.length == 1 || !this.lineTypes.some(lineType => lineType.Value == this.lastClockinType)
        ? this.lineTypes[0].Value
        : this.lastClockinType;

    this.formData.lineType == 'J' ? this.getJobs() : this.getWorkOrder();
  }

  async getJobs(): Promise<void> {
    this.jobs = [];
    const response = await this.homeService.getJobs('TC');
    if (response != null) {
      const jobs = response;
      for (let i = 0; i < jobs.length; i++) {
        jobs[i].DisplayValue = 'JCCo ' + jobs[i].JCCo + ' - ' + jobs[i].JobDisplayName;
        if (this.employeeInfo.LastUsedJCJMKeyID != null && jobs[i].JCJMKeyID == this.employeeInfo.LastUsedJCJMKeyID && this.prefillJP) {
          this.formData.selectedJob = jobs[i];
        }
      }
      if (this.formData.selectedJob != null) {
        this.getPhases();
      }
      this.jobs = jobs;
      if (this.tcClockIOIgnoreJobPhase) {
        this.jobs.unshift({ JCJMKeyID: null, DisplayValue: 'No Job', JCCo: null, Job: '', JobDescription: '', JobDisplayName: '' });
      }
    }
  }

  jobChanged(): void {
    this.formData.selectedPhase = null;
    this.homeService.setJob(this.formData.selectedJob.JCJMKeyID, this.employeeInfo.UserKeyID);
    this.getPhases();
  }

  async getPhases(): Promise<void> {
    this.phases = [];
    if (this.formData.selectedJob?.JCJMKeyID != null) {
      const response = await this.homeService.getPhasesByJCJMKeyID(this.formData.selectedJob.JCJMKeyID);
      if (response != null) {
        const phases = response;
        if (this.prefillJP) {
          for (let i = 0; i < phases.length; i++) {
            if (this.employeeInfo.LastUsedJCJPKeyID != null && this.employeeInfo.LastUsedJCJPKeyID == phases[i].JCJPKeyID) {
              this.formData.selectedPhase = phases[i];
            }
          }
        }
        this.phases = phases;
        if (this.tcClockIOIgnoreJobPhase) {
          this.phases.unshift({ JCJPKeyID: null, Phase: '', PhaseDescription: 'No Phase', PhaseGroup: null });
        }
      }
    } else {
      if (this.tcClockIOIgnoreJobPhase) {
        this.phases.unshift({ JCJPKeyID: null, Phase: '', PhaseDescription: 'No Phase', PhaseGroup: null });
      }
    }
  }

  clockInClicked(): void {
    this.userAction = 'Clock In';
    this.bsModalRef.hide();
  }

  cancelClicked(): void {
    this.userAction = 'cancel';
    this.bsModalRef.hide();
  }

  async getWorkOrder(): Promise<void> {
    this.workOrderList = [];
    const response = await this.smService.getWorkOrderTripsByEmployee(this.employeeInfo.Employee, this.employeeInfo.PRCo);
    if (response != null && Array.isArray(response)) {
      this.workOrderList = response.map(val => ({
        ...val,
        ScheduledDateDisplay: val.ScheduledDate != null ? moment(val.ScheduledDate).utc().format('DD/MMM') : '',
        Display: `${val.ScheduledDate != null ? moment(val.ScheduledDate).utc().format('DD/MMM') + ' - ' : ''}WO #${val.WorkOrder} ${val.TripDescription}`,
      }));
    }
  }

  async getScope(): Promise<void> {
    this.scopeList = [];
    const response = await this.smService.getWorkOrderScopes('?sMWorkOrderID=' + this.formData.workOrder.SMWorkOrderID);
    if (response != null && Array.isArray(response)) {
      this.scopeList = response;
      this.scopeList = response.map(val => ({
        ...val,
        Display: val.Scope + ' - ' + val.ScopeDetails,
      }));
    }
  }

  async getPayType(): Promise<void> {
    this.payTypeList = [];
    if (this.formData.workOrder.SMCo != null) {
      const response = await this.smService.getSMPayTypes(this.formData.workOrder.SMCo);
      if (response != null && Array.isArray(response)) {
        this.payTypeList = response.map(val => ({
          ...val,
          Display: val.DatabaseValue + ' - ' + val.DisplayValue,
        }));
      }
    }
  }

  workOrderChanged(): void {
    this.formData.scope = null;
    this.formData.payType = null;
    if (this.formData.workOrder != null) {
      this.getScope();
      this.getPayType();
    } else {
      this.scopeList = [];
      this.payTypeList = [];
    }
  }

  typeChanged(): void {
    if (this.formData.lineType == 'J') {
      this.formData.selectedJob = null;
      this.formData.selectedPhase = null;
      this.phases = [];
      this.getJobs();
    } else {
      this.formData.workOrder = null;
      this.formData.scope = null;
      this.formData.payType = null;
      this.scopeList = [];
      this.payTypeList = [];
      this.getWorkOrder();
    }
  }

  disableClockinButton() {
    return (
      (this.formData.lineType == 'J' &&
        (this.formData.selectedJob?.JCJMKeyID == null || this.formData.selectedPhase?.JCJPKeyID == null) &&
        !this.tcClockIOIgnoreJobPhase) ||
      (this.tcClockIOIgnoreJobPhase && (this.formData.selectedJob == null || this.formData.selectedPhase == null)) ||
      (this.formData.lineType == 'S' && (this.formData.workOrder == null || this.formData.scope == null || this.formData.payType == null))
    );
  }
}
